<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link to="/rfp/parts" class="nav-link">Parts</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/rfp/vendors" class="nav-link">Vendors</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/rfp/offers" class="nav-link">Offers</router-link>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane active">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
};
</script>
